export const createSystemTypeToDeviceMap = (devices) => {
  const map = new Map();

  devices.forEach((device) => {
    const systemType = device?.system_type?.toUpperCase();
    if (!map.has(systemType)) {
      map.set(systemType, []);
    } else {
      map.get(systemType).push(device);
    }
  });

  return map;
};

// The command fields an operator can edit through DeviceControls.
const COMMAND_DRAFT_FIELDS = [
  'status',
  'maintenanceOverride',
  'comments',
  'interval',
  'volume',
  'repeat',
  'audio',
  'audioIndex',
];

/**
 * The command fields that differ between the draft an edit started from and the edited draft.
 * @returns {import('features/Integrations/types/deviceControl.types').CommandDraftField[]}
 */
export const getChangedCommandFields = (previousDraft, nextDraft) =>
  COMMAND_DRAFT_FIELDS.filter((field) => previousDraft?.[field] !== nextDraft?.[field]);

// Keep only the command fields the operator edited when observed device data refreshes.
// A field the operator did not touch is left out, so DeviceControls derives it again from
// the live device. A value DeviceControls derived when the modal opened (status, audio)
// must follow the device: a later Save would otherwise send a status the device no longer has.
export const mergeCommandDraft = (device, draft, editedFields = []) => {
  const merged = { ...device };
  editedFields.forEach((field) => {
    merged[field] = draft[field];
  });
  // DeviceControls derives status and toggle_switch_text together when either one is
  // missing, which would replace an edited status. The switch label is a reading of the
  // device, never an edit, so it is read from the live device here.
  if (editedFields.includes('status')) {
    merged.toggle_switch_text = device?.data?.[0]?.toggle_switch ? 'On' : 'Off';
  }
  return merged;
};
